import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getInformacionesSumarias from '../../../graphql/querys/tramites/getInformacionesSumarias.graphql';
import deleteInformacionSumaria from '../../../graphql/mutations/tramites/deleteInformacionSumaria.graphql';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getInformacionesSumariasPorRango from '../../../graphql/querys/tramites/getInformacionesSumariasPorRango.graphql';

import { descargarCSV } from '../funciones/descargarCSV';
import TablaInformacionSumaria from './TablaInformacionSumaria';

import convertBase64toBlob from '../../common/documentos/convertBase64toBlob';
import ReImprimirNota from '../ReImprimirNota';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;
@compose(
  graphql(getUsuario),
  graphql(deleteInformacionSumaria, {
    name: 'deleteInformacionSumaria',
    options: {
      refetchQueries: [{ query: getInformacionesSumarias }],
    },
  })
)
class VerInformacionSumaria extends React.Component {
  constructor(props) {
    super(props);

    let fechaIni = moment()
      .subtract(7, 'd')
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    fechaIni = fechaIni.toDate();

    let fechaFin = moment().endOf('day');
    fechaFin = fechaFin.toDate();

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
      imprimir: false,
      datosImpresion: {},
      fechaInicio: fechaIni,
      fechaFin: fechaFin,
      loadingTabla: false,
    };

    this.onDelete = this.onDelete.bind(this);

    // this.buscarInformacionesSumariasPorFecha(fechaIni, fechaFin);
  }

  componentDidMount() {
    this.buscarInformacionesSumariasPorFecha(
      this.state.fechaInicio,
      this.state.fechaFin
    );
  }

  buscarInformacionesSumariasPorFecha = (fechaIni, fechaFin) => {
    this.setState({
      loadingTabla: true,
    });
    this.props.client
      .query({
        query: getInformacionesSumariasPorRango,
        variables: {
          fechaInicial: fechaIni,
          fechaFinal: fechaFin,
        },
      })
      .then(res => {
        this.setState(
          {
            ...this.state,
            listaTotal: res.data.getInformacionesSumariasPorRango,
            primeraCarga: false,
            loadingTabla: false,
          },
          function() {
            this.ordenarLista(1, 10);
          }
        );
      })
      .catch(err => {
        console.log('ERROR EN EL INFORMACIONES SUMARIAS POR RANGO: ');
        console.log(err);

        Modal.error({
          title: 'Error en la busqueda de informaciones sumarias',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  onDelete(id) {
    //TODO: Hacer el onDelete.
    // console.log("Se desea eliminar la declaracion jurada con id ", id);

    let { usuario } = this.props;

    if (usuario.rol == 'SUPERVISOR' || usuario.rol == 'FUNCIONARIO') {
      let yo = this;
      confirm({
        title:
          'Realmente quiere eliminar esta informacion sumaria y su respectiva venta?',
        content: 'Esta accion no podrá deshacerse',
        onOk() {
          yo.props
            .deleteInformacionSumaria({
              variables: { _id: id },
            })
            .then(res => {
              // console.log("La respuesta del delete fue....");
              // console.log(res);

              let id = res.data.deleteInformacionSumaria;

              if (id) {
                yo.eliminarElementoYActualizarLista(id);

                notification.warning({
                  message:
                    'Informacion Sumaria y su respectiva venta eliminadas correctamente',
                  description: 'Se ha eliminado la IS exitosamente',
                });
              }
            })
            .catch(err => {
              console.log('Existio un error a la hora de eliminar la IS');
              console.log(err);

              Modal.error({
                title: 'Error en la eliminacion de la IS',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });

              errorService(err, {
                _id: id,
                usuario,
                accion: 'ELIMINAR IS',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      Modal.error({
        title:
          'Usted no tiene los permisos necesarios para realizar esta operación',
        content:
          'Para poder realizar esta función, debe tener mas permisos en su cuenta de los que tiene ahora mismo. Por favor, en caso de ser necesario, comuníquese con mesa de ayuda del departamento de informática.',
      });
    }
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(
      this.props.data.getDeclaracionesJuradas,
      certificacion => {
        return (
          certificacion.declarante.nombre
            .toUpperCase()
            .indexOf(filtro.toUpperCase()) > -1
        );
      }
    );

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(
      this.props.data.getDeclaracionesJuradas,
      certificacion => {
        return (
          certificacion.declarante.apellido
            .toUpperCase()
            .indexOf(filtro.toUpperCase()) > -1
        );
      }
    );

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorDocumento = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(
      this.props.data.getDeclaracionesJuradas,
      certificacion => {
        return (
          certificacion.declarante.num_doc
            .toUpperCase()
            .indexOf(filtro.toUpperCase()) > -1
        );
      }
    );

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (nextProps.getInformacionesSumarias.getInformacionesSumarias) {

  //     // console.log("Recibi declaraciones ", nextProps.data.getDeclaracionesJuradas);
  //     this.setState(
  //       {
  //         ...this.state,
  //         listaTotal: nextProps.getInformacionesSumarias.getInformacionesSumarias,
  //         primeraCarga: false
  //       },
  //       function () {
  //         this.ordenarLista(1, 10);
  //       }
  //     );
  //   }
  // }

  ordenarLista = (numPagina, tamPagina) => {
    // console.log("Listaaaa");
    // console.log(this.state.listaTotal);
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        declaracion => {
          // return declaracion.declarante.apellido.toUpperCase();
          return declaracion.fecha_creacion;
        },
      ],
      ['desc']
    );

    let listaCorta = _.slice(
      listaOrdenada,
      0 + (numPagina - 1) * tamPagina,
      tamPagina * numPagina
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaCorta,
    });
  };

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    this.setState(
      {
        ...this.state,
        fechaInicio: date[0]
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate(),
        fechaFin: date[1]
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toDate(),
      },
      () => {
        this.buscarInformacionesSumariasPorFecha(
          this.state.fechaInicio,
          this.state.fechaFin
        );
      }
    );
  };

  onImprimir = registro => {
    // console.log("El registro que me llego es.....");
    // console.log(registro);

    this.setState(
      {
        ...this.state,
        loading: true,
      },
      () => {
        let textoOperacion = `Este tramite fue exento del pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
        if (registro && registro.venta) {
          let venta = registro.venta;
          textoOperacion = `Por este trámite se abono la suma de $${venta.importe} mediante el uso de ${venta.tipoPago}, en concepto de pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
        }
        let datos = {
          ...registro.declarante,
          modelo_nota: registro.modelo_nota,
          fecha_nacimiento: registro.declarante.fecha_nacimiento
            ? moment(registro.declarante.fecha_nacimiento).toDate()
            : '',
          edad: registro.declarante.fecha_nacimiento
            ? Math.floor(
                moment(new Date()).diff(
                  moment(registro.declarante.fecha_nacimiento),
                  'years',
                  true
                )
              )
            : '',
          direccion_otro:
            registro.declarante.direccion_otro &&
            registro.declarante.direccion_otro.length > 0
              ? registro.declarante.direccion_otro
              : ' ',
          testigo1: {
            ...registro.testigo1,
            localidad:
              registro.testigo1.localidad && registro.testigo1.localidad.nombre
                ? registro.testigo1.localidad.nombre
                : registro.testigo1.localidad,
            fecha_nacimiento: registro.testigo1.fecha_nacimiento
              ? moment(registro.testigo1.fecha_nacimiento).toDate()
              : '',
            edad: registro.testigo1.fecha_nacimiento
              ? Math.floor(
                  moment(new Date()).diff(
                    moment(registro.testigo1.fecha_nacimiento),
                    'years',
                    true
                  )
                )
              : '',
            direccion_otro:
              registro.testigo1.direccion_otro &&
              registro.testigo1.direccion_otro.length > 0
                ? registro.testigo1.direccion_otro
                : ' ',
          },
          testigo2: {
            ...registro.testigo2,
            localidad:
              registro.testigo2.localidad && registro.testigo2.localidad.nombre
                ? registro.testigo2.localidad.nombre
                : registro.testigo2.localidad,
            fecha_nacimiento: registro.testigo2.fecha_nacimiento
              ? moment(registro.testigo2.fecha_nacimiento).toDate()
              : '',
            edad: registro.testigo2.fecha_nacimiento
              ? Math.floor(
                  moment(new Date()).diff(
                    moment(registro.testigo2.fecha_nacimiento),
                    'years',
                    true
                  )
                )
              : '',
            direccion_otro:
              registro.testigo2.direccion_otro &&
              registro.testigo2.direccion_otro.length > 0
                ? registro.testigo2.direccion_otro
                : ' ',
          },
          testimonio: registro.testimonio,
          ente_receptor: registro.ente_receptor,
          numero: registro.numero,
          organismo: registro.organismo,
          fecha_creacion: new Date(registro.fecha_creacion),
          textoOperacion,
        };

        // console.log("Los datos de impresion es....");
        // console.log(datosImpresion);

        this.setState({
          ...this.state,
          loading: false,
          datosImpresion: datos,
          imprimir: true,
        });
      }
    );
  };

  onDescargar = () => {
    // console.log("entre a descargar");
    let data = _.map(this.state.listaTotal, declaracion => {
      return {
        tipo_doc: declaracion.declarante.tipo_doc,
        num_doc: declaracion.declarante.num_doc,
        nombre: declaracion.declarante.nombre,
        apellido: declaracion.declarante.apellido,
        fecha: moment(declaracion.fecha_creacion).format('DD/MM/YYYY'),
        usuario: declaracion.creador
          ? declaracion.creador.apellido.toUpperCase()
          : '-',
      };
    });
    descargarCSV(
      ['Tipo Doc', 'Num Doc', 'Nombre', 'Apellido', 'Fecha', 'Usuario'],
      data,
      `ReporteDeInformacionSumaria-${moment().format('DD/MM/YYYY-HH:mm')}.csv`
    );
  };

  generarRecibo = base64 => {
    const base64PdfBlob = convertBase64toBlob(base64, 'application/pdf');
    const filePdf = URL.createObjectURL(base64PdfBlob);
    window.open(filePdf);
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };
    return (
      <div>
        {!this.state.imprimir && (
          <TablaInformacionSumaria
            informacionesSumarias={this.state.lista}
            history={this.props.history}
            onDelete={this.onDelete}
            pagination={pagination}
            filtrarPorNombre={this.filtrarPorNombre}
            filtrarPorApellido={this.filtrarPorApellido}
            filtrarPorDocumento={this.filtrarPorDocumento}
            imprimir={this.onImprimir}
            onChange={this.onChange}
            onDescargar={this.onDescargar}
            fechaInicio={this.state.fechaInicio}
            fechaFin={this.state.fechaFin}
            loadingTabla={this.state.loadingTabla}
            usuario={this.props.usuario}
            generarRecibo={this.generarRecibo}
          />
        )}

        {this.state.imprimir && (
          <ReImprimirNota
            datos={this.state.datosImpresion}
            idModeloNota={this.state.datosImpresion.modelo_nota._id}
            onCancel={() => this.setState({ ...this.state, imprimir: false })}
          />
        )}
      </div>
    );
  }
}

export default withApollo(VerInformacionSumaria);
